import React from 'react';

import classes from './Radio.module.scss';

const Radio = ({ id, value, onChange, type = 'standard', name }) => {
  const onChangeHandler = event => {
    onChange(event.target.value);
  };

  const radioName = name || 'radio-name';

  return (
    <>
      <label className={classes.container}>
        <input type='radio' className='' name={radioName} onChange={onChangeHandler} checked={value === id} value={id} />
        <span className={`${classes.checkmark} ${classes[`checkmark-${type}`]} ${classes[`check-${type}`]}`} name={radioName}></span>
      </label>
    </>
  );
};

export default Radio;
